import { useMemo } from 'react';
import { useBusiness } from './useApi';

export interface ProfileCompletion {
  isComplete: boolean;
  missingFields: string[];
  completionProgress: number;
}

export function useProfileCompletion(): ProfileCompletion {
  const { data: business } = useBusiness();

  return useMemo(() => {
    if (!business) {
      return {
        isComplete: false,
        missingFields: [],
        completionProgress: 0,
      };
    }

    const requiredFields = [
      { key: 'name', label: 'Company Name' },
      { key: 'fein', label: 'FEIN' },
      { key: 'streetAddress', label: 'Street Address' },
      { key: 'city', label: 'City' },
      { key: 'state', label: 'State' },
      { key: 'zip', label: 'ZIP Code' },
      { key: 'ownerEmail', label: 'Email Address' },
      { key: 'payFrequency', label: 'Pay Frequency' },
      { key: 'endOfWeek', label: 'Week Ending Day' },
      { key: 'payCheckDelay', label: 'Pay Check Delay' },
    ];

    const missingFields: string[] = [];
    let filledCount = 0;

    requiredFields.forEach(({ key, label }) => {
      const value = business[key as keyof typeof business];
      if (!value && value !== 0) {
        // Allow 0 for endOfWeek and payCheckDelay
        missingFields.push(label);
      } else {
        filledCount++;
      }
    });

    const completionProgress = Math.round(
      (filledCount / requiredFields.length) * 100
    );
    const isComplete = missingFields.length === 0;

    return {
      isComplete,
      missingFields,
      completionProgress,
    };
  }, [business]);
}
